import styled, { keyframes } from 'styled-components';

interface SearchLoaderProps {
  isFetching: boolean;
}
const SearchLoader = ({ isFetching }: SearchLoaderProps) => {
  return (
    <>
      {isFetching ? (
        <Container>
          <div className={isFetching ? 'loader' : ''}></div>
          <div className={isFetching ? 'loader' : ''}></div>
        </Container>
      ) : (
        <></>
      )}
    </>
  );
};

const loaderProgress = (firstPoint: number, secondPoint: number) => keyframes`
  0% {
      left: 50%;
    }
    50% {
      left: ${firstPoint}%;
    }
    100% {
      left: ${secondPoint}%;
    }
`;

const Container = styled.div`
  width: 100%;
  height: 2px;
  background-color: #edf1f6;
  position: relative;

  .loader {
    position: absolute;
    top: 0;
    left: 50%;
    width: 10px;
    height: 100%;
    background-color: #015c9a;
    &:nth-child(1) {
      animation: ${loaderProgress(65, 100)} 2s infinite;
    }
    &:nth-child(2) {
      animation: ${loaderProgress(35, 0)} 2s infinite;
    }
  }
`;
export default SearchLoader;
